<template>
  <v-list-item dense :disabled="disabled" v-on="$listeners">
    <v-list-item-icon v-if="icon">
      <v-icon dense v-text="icon" />
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'DropdownMenuItemDefault',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
